import dayjs from 'dayjs';

import * as apiMethods from '../../consts/api/apiMethods';
import {setKvkData, setKvkSettingsData, setKvkStatisticsData, setKvkStatus} from '../../state/ducks/services';
import ApiClient from '../api/clients/apiClient';
import ModulesHostApiClient from '../api/clients/modulesHostApiClient';
import {buildAllHistoryExcelFile} from '../download/downloadService';
import log from '../logger/log';
import {showNotification} from './servicesService';

const showSuccessNotification = (message) => {
    let notification = document.getElementById('notification-center');

    if (!notification) {
        notification = document.createElement('div');
        notification.id = 'notification-center';
        document.body.appendChild(notification);
    }

    notification.style.position = 'fixed';
    notification.style.top = '20px';
    notification.style.left = '50%';
    notification.style.transform = 'translateX(-50%)';
    notification.style.backgroundColor = '#4caf50';
    notification.style.color = '#fff';
    notification.style.padding = '15px 30px';
    notification.style.borderRadius = '8px';
    notification.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
    notification.style.fontSize = '16px';
    notification.style.fontWeight = 'bold';
    notification.style.textAlign = 'center';
    notification.style.zIndex = '10000';

    notification.textContent = message;

    setTimeout(() => {
        notification.remove();
    }, 3000); // Сповіщення зникне через 3 секунди
};

const showLoadingNotification = (message) => {
    let notification = document.getElementById('notification-center');

    if (!notification) {
        notification = document.createElement('div');
        notification.id = 'notification-center';
        document.body.appendChild(notification);
    }

    notification.style.position = 'fixed';
    notification.style.top = '20px';
    notification.style.left = '50%';
    notification.style.transform = 'translateX(-50%)';
    notification.style.backgroundColor = 'grey';
    notification.style.color = '#fff';
    notification.style.padding = '15px 30px';
    notification.style.borderRadius = '8px';
    notification.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
    notification.style.fontSize = '16px';
    notification.style.fontWeight = 'bold';
    notification.style.textAlign = 'center';
    notification.style.zIndex = '10000';

    notification.textContent = message;

    setTimeout(() => {
        notification.remove();
    }, 3000); // Сповіщення зникне через 3 секунди
};

const getKvkBuildingLists = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_KVK_BUILDING_LISTS,
            action: setKvkData,
        });
    } catch (e) {
        log.error(`getBuildingsList: ${e}`);
    }
};

const getKvkBuildingListsForModal = async () => {
    try {
        const result = await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_KVK_BUILDING_LISTS,
            action: setKvkData,
        });

        return result;
    } catch (e) {
        log.error(`getBuildingsList: ${e}`);
    }
};

const addBuildingToApplied = async ({data, onRequestSuccess}) => {
    await new ApiClient().callPost({
        methodName: apiMethods.SERVICES_KVK_BUILDING_LISTS,
        // mapper: buildingToAppliedMapping,
        requestConfig: {
            data,
        },
        onResponse: onRequestSuccess,
    });
};

const getKvkStatus = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_KVK_STATE,
            action: setKvkStatus,
        });
    } catch (e) {
        log.error(`getKvkStatus: ${e}`);
    }
};

const turnOffKvkDataSending = async ({onRequestSuccess}) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.SERVICES_KVK_OFF,
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`turnOffKvkDataSending: ${e}`);
    }
};

const turnOnKvkDataSending = async ({onRequestSuccess}) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.SERVICES_KVK_ON,
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`turnOnKvkDataSending: ${e}`);
    }
};

const getKvkStatistics = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_KVK_STATISTICS,
            action: setKvkStatisticsData,
        });
    } catch (e) {
        log.error(`getKvkStatistics: ${e}`);
    }
};

const getKvkSettings = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.SERVICES_KVK_SETTINGS,
            action: setKvkSettingsData,
        });
    } catch (e) {
        log.error(`getKvkSettings: ${e}`);
    }
};

const updateKvkSettings = async ({data, onRequestSuccess}) => {
    await new ApiClient().callPost({
        methodName: apiMethods.SERVICES_KVK_SETTINGS,
        requestConfig: {
            data,
        },
        onResponse: onRequestSuccess,
    });

    await new ModulesHostApiClient().callPost({
        methodName: 'schedulers/kvk',
    });
};

const executeKvk = async () => {
    try {
        const state = await new ModulesHostApiClient().callGet({
            methodName: 'schedulers/kvk',
        });

        if (state.status === 1) {
            await new ModulesHostApiClient().callPost({
                methodName: 'schedulers/kvk/execute',
            });

            showSuccessNotification('Дані успішно відправлено!');
        } else if (state.status === 2) {
            showLoadingNotification('Дані вже було відправленно!');
        } else {
            showNotification('Не можна відправити дані!');
        }
    } catch (e) {
        console.error(`ExecuteKvk: ${e}`);
    }
};

const getKvkBuildingStatisticsHistory = async (buildingId, startDate, endDate) => {
    console.log('API Call Params:', {buildingId, startDate, endDate});
    try {
        const response = await new ApiClient().callGet({
            methodName: `modules/kvk/statistics/history/download/building/${buildingId}`,
            requestConfig: {
                params: {
                    startDate,
                    endDate,
                },
            },
        });

        console.log('Response:', response);

        if (!response?.buildingResults || response.buildingResults.length === 0) {
            console.warn('No statistics data found in the response');
            showNotification('Статистика за вибраний період відсутня.', 'warning');
            return;
        }

        const formatDate = (dateString) => (dateString ? dayjs(dateString).format('YYYY-MM-DD') : 'N/A');

        const dataForExcel = response.buildingResults.flatMap((building) => {
            const failedDevices = (building.Result.FailedDevices || []).map((device) => ({
                EventDate: building.EventTs || 'N/A',
                BuildingID: building.Result.BuildingId || 'N/A',
                BuildingAddress: building.Result.BuildingAddress || 'N/A',
                DeviceType: 'SucceedDevice',
                DeviceID: device.DeviceID || 'N/A',
                DeviceNumber: device.DeviceNumber || 'N/A',
                KvkID: device.KvkID || 'N/A',
                Error: device.Error || 'N/A',
                FactoryID: device.FactoryID || 'N/A',
                Indicator: device.Indicator || 'N/A',
                Value: device.Value || 'N/A',
                Unit: device.Unit || 'N/A',
                Date: formatDate(device.Date),
                LocalDate: device.LocalDate || 'N/A',
            }));

            const succeedDevices = (building.Result.SucceedDevices || []).map((device) => ({
                EventDate: building.EventTs || 'N/A',
                BuildingID: building.Result.BuildingId || 'N/A',
                BuildingAddress: building.Result.BuildingAddress || 'N/A',
                DeviceType: 'SucceedDevice',
                DeviceID: device.DeviceID || 'N/A',
                DeviceNumber: device.DeviceNumber || 'N/A',
                KvkID: device.KvkID || 'N/A',
                Error: device.Error || 'N/A',
                FactoryID: device.FactoryID || 'N/A',
                Indicator: device.Indicator || 'N/A',
                Value: device.Value || 'N/A',
                Unit: device.Unit || 'N/A',
                Date: formatDate(device.Date),
                LocalDate: device.LocalDate || 'N/A',
            }));

            return [...failedDevices, ...succeedDevices];
        });

        console.log('Data prepared for Excel:', dataForExcel);

        if (dataForExcel.length > 0) {
            const fileName = `KVKBuilding_${formatDate(new Date().toISOString())}.xlsx`;

            buildAllHistoryExcelFile(dataForExcel, fileName);
            console.log(`Excel file "${fileName}" created successfully.`);
        } else {
            console.warn('No valid data to write to Excel');
        }

        return response;
    } catch (e) {
        console.error(`Error in getBuildingStatisticsHistory: ${e.message}`, e);
        throw e;
    }
};

const getKvkHistoryExcelStatistics = async (startDate, endDate) => {
    try {
        console.log('Start Date:', startDate);
        console.log('End Date:', endDate);

        const response = await new ApiClient().callGet({
            methodName: 'modules/kvk/statistics/history/download',
            requestConfig: {
                params: {startDate, endDate},
            },
        });

        if (!response?.Statistics || response.Statistics.length === 0) {
            console.warn('No statistics data found in the response');

            showNotification('Статистика за вибраний період відсутня.', 'warning');
            return;
        }

        const formatDate = (dateString) => (dateString ? dayjs(dateString).format('YYYY-MM-DD') : '-');

        const fileName = `KVKHistory_${formatDate(new Date().toISOString())}.xlsx`;

        const dataForExcel = response.Statistics.flatMap((stat) =>
            stat.Results.flatMap((result) => {
                return result.FailedDevices.map((device) => ({
                    BuildingID: result.BuildingId || 'N/A',
                    BuildingAddress: result.BuildingAddress || 'N/A',
                    DeviceID: device.DeviceID || 'N/A',
                    DeviceNumber: device.DeviceNumber || 'N/A',
                    KvkID: device.KvkID || 'N/A',
                    Indicator: device.Indicator || 'N/A',
                    FactoryID: device.FactoryID || 'N/A',
                    Value: device.Value || 'N/A',
                    Unit: device.Unit || 'N/A',
                    Error: device.Error || 'N/A',
                    Date: formatDate(device.Date),
                    LocalDate: device.LocalDate || 'N/A',
                }));
            })
        );

        console.log('Data prepared for Excel:', dataForExcel);

        buildAllHistoryExcelFile(dataForExcel, fileName);

        console.log(`Excel file "${fileName}" created successfully.`);

        return response;
    } catch (e) {
        console.error(`Error in getKvkHistoryExcelKteStatistics: ${e.message}`, e);
        return null;
    }
};

export default {
    getKvkBuildingLists,
    addBuildingToApplied,
    getKvkStatus,
    turnOffKvkDataSending,
    turnOnKvkDataSending,
    getKvkSettings,
    updateKvkSettings,
    getKvkStatistics,
    executeKvk,
    getKvkBuildingStatisticsHistory,
    getKvkHistoryExcelStatistics,
    getKvkBuildingListsForModal,
};
